if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        this.teardownThumbnailHeightSync();
        this.clearThumbnailRailStyles();
        const cartNotification =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener.querySelector(".loading__spinner").classList.remove("hidden");

        const productUrl = opener.getAttribute("data-product-url");
        if (!productUrl) {
          console.error(
            "Error: El botón no tiene el atributo data-product-url"
          );
          return;
        }

        fetch(productUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]'
            );

            // PROTECCIÓN: Si no existe el elemento, no seguimos
            if (!this.productElement) return;

            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton)
              Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.forceModalGalleryImagesLoad();
            this.preventVariantURLSwitching();
            super.show(opener);

            this.syncModalVariantMedia();
            this.initQuickAddGift();
            this.setupThumbnailHeightSync();
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      preventDuplicatedIDs() {
        if (!this.productElement?.dataset) return;
        const sectionId = this.productElement.dataset.section;
        if (!sectionId) return;

        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
          sectionId,
          `quickadd-${sectionId}`
        );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios, product-info")
          .forEach((el) => (el.dataset.originalSection = sectionId));
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll("script").forEach((oldScript) => {
          const newScript = document.createElement("script");
          Array.from(oldScript.attributes).forEach((attr) =>
            newScript.setAttribute(attr.name, attr.value)
          );
          newScript.appendChild(document.createTextNode(oldScript.innerHTML));
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      }

      initQuickAddGift() {
        const modal = this.modalContent;
        const giftCheckbox = modal.querySelector("#gift-checkbox");
        const nativeForm = modal.querySelector("product-form form");
        const nativeSubmitBtn = modal.querySelector('[name="add"]');

        if (!nativeSubmitBtn || !nativeForm) return;

        // 1. Clonamos el botón para matar los listeners de Shopify/Dawn
        // Esto nos da un botón "limpio" que no enviará el formulario automáticamente
        const customBtn = nativeSubmitBtn.cloneNode(true);
        customBtn.type = "button"; // Evitamos que sea 'submit'
        customBtn.classList.add("custom-added-btn");
        nativeSubmitBtn.parentNode.replaceChild(customBtn, nativeSubmitBtn);

        customBtn.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();
      
          customBtn.setAttribute('aria-disabled', 'true');
          customBtn.classList.add('loading');
          const spinner = customBtn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
      
          try {
            const variantId = modal.querySelector('input[name="id"]').value;
            const isGiftChecked = giftCheckbox && giftCheckbox.checked;
            const giftVariantId = isGiftChecked ? giftCheckbox.value : null;
            
            let properties = {};
            let bundleId = null;
      
            // --- LÓGICA DE RECICLAJE DE ID ---
            // Consultamos el carrito actual antes de agregar
            const cartStatus = await fetch('/cart.js').then(r => r.json());
            
            // Buscamos si ya existe esta variante con un BundleId
            const existingItem = cartStatus.items.find(item => 
              item.variant_id == variantId && 
              item.properties && 
              item.properties._BundleId
            );
      
            if (existingItem) {
              // Si ya existe, usamos su ID para que Shopify sume la cantidad en la misma línea
              bundleId = existingItem.properties._BundleId;
              properties['_BundleId'] = bundleId;
            } else if (isGiftChecked) {
              // Si no existe pero el usuario quiere bolsa, creamos uno nuevo
              bundleId = 'bundle_' + Date.now();
              properties['_BundleId'] = bundleId;
            }
            // ---------------------------------
      
            // 1. AGREGAR PRODUCTO PRINCIPAL
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{
                  id: variantId,
                  quantity: 1,
                  properties: properties
                }]
              })
            });
      
            if (!response.ok) throw new Error('Error al agregar');
      
            // 2. AGREGAR BOLSA (Solo si el checkbox está marcado)
            // Nota: Si el ID fue reciclado, window.addGiftToCart sumará +1 a la bolsa existente 
            // porque recibirá el mismo ID y variante.
            if (isGiftChecked && bundleId) {
              await window.addGiftToCart(giftVariantId, bundleId);
            }
      
            // 3. FINALIZAR
            if (window.forceBagCorrection) await window.forceBagCorrection();
            await refreshCartDrawer(); // Esta función ya tiene el fix de las clases arriba
      
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              if (typeof cartDrawer.open === 'function') cartDrawer.open();
              else cartDrawer.classList.add('active');
            }
            
            this.hide();
      
          } catch (error) {
            console.error('[GiftDebug] Error:', error);
          } finally {
            customBtn.removeAttribute('aria-disabled');
            customBtn.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          }
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector(
          "variant-radios,variant-selects"
        );
        if (!variantPicker) return;
        variantPicker.setAttribute("data-update-url", "false");
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector(
          "pickup-availability"
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        this.productElement
          .querySelectorAll("modal-dialog")
          .forEach((modal) => modal.remove());
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;
        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        if (!product.classList.contains("product--columns")) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let sizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";
        if (product.classList.contains("product--medium"))
          sizes = sizes.replace("715px", "605px");
        else if (product.classList.contains("product--small"))
          sizes = sizes.replace("715px", "495px");

        mediaImages.forEach((img) => img.setAttribute("sizes", sizes));
      }

      /** Contenido inyectado en un modal: lazy-loading a veces no reevalúa hasta scroll/viewport. */
      forceModalGalleryImagesLoad() {
        const root = this.modalContent;
        if (!root) return;
        root.querySelectorAll(".product__media img[loading='lazy']").forEach((img) => {
          img.loading = "eager";
        });
        root.querySelectorAll(".product__media img").forEach((img) => {
          if (img.complete) return;
          const src = img.currentSrc || img.src;
          if (src) img.src = src;
        });
      }

      /** Miniaturas custom.media: Liquid las deja en display:none hasta filtrar por variante (no hay ?variant= en el modal). */
      syncModalVariantMedia() {
        const productRoot = this.modalContent.querySelector(".product");
        const vid = productRoot?.querySelector('input[name="id"]')?.value;
        if (
          !productRoot ||
          !vid ||
          typeof window.syncVariantMediaVisibility !== "function"
        )
          return;
        requestAnimationFrame(() => {
          window.syncVariantMediaVisibility(productRoot, vid);
          setTimeout(() => this.syncThumbnailRailWithMainImage(), 280);
        });
      }

      /**
       * A partir de 1325px las miniaturas van al costado con max-height:555px fijo en el tema;
       * en el modal la imagen principal suele ser más baja y la columna se ve más alta.
       */
      syncThumbnailRailWithMainImage() {
        if (!this.modalContent) return;
        const product = this.modalContent.querySelector(".product--thumbnail");
        if (!product) return;
        if (!window.matchMedia("(min-width: 1325px)").matches) {
          this.clearThumbnailRailStyles();
          return;
        }

        const activeMedia = product.querySelector(
          ".product__media-item.is-active .product-media-container"
        );
        const list = product.querySelector(".thumbnail-list");
        const arrowDown = product.querySelector(".arrow-down-scroll");
        if (!activeMedia || !list) return;

        const mainH = activeMedia.getBoundingClientRect().height;
        if (mainH < 40) return;

        const listActive = list.classList.contains("list-active");
        const topReserve = listActive ? 65 : 36;
        const bottomReserve = 46;
        const listMax = Math.max(88, Math.round(mainH - topReserve - bottomReserve));

        list.style.maxHeight = `${listMax}px`;
        if (arrowDown) {
          arrowDown.style.top = `${Math.round(topReserve + listMax + 8)}px`;
        }
      }

      setupThumbnailHeightSync() {
        this.teardownThumbnailHeightSync();
        const wrapper = this.modalContent?.querySelector(".product__media-wrapper");
        if (!wrapper) return;

        const sync = () => this.syncThumbnailRailWithMainImage();

        requestAnimationFrame(() => {
          sync();
          setTimeout(sync, 120);
          setTimeout(sync, 400);
        });

        if (typeof ResizeObserver !== "undefined") {
          this._thumbResizeObs = new ResizeObserver(() => {
            clearTimeout(this._thumbObsDebounce);
            this._thumbObsDebounce = setTimeout(sync, 60);
          });
          this._thumbResizeObs.observe(wrapper);
        }

        this._thumbWindowResize = () => {
          if (window.matchMedia("(min-width: 1325px)").matches) sync();
          else this.clearThumbnailRailStyles();
        };
        window.addEventListener("resize", this._thumbWindowResize);
      }

      teardownThumbnailHeightSync() {
        clearTimeout(this._thumbObsDebounce);
        this._thumbObsDebounce = null;
        if (this._thumbResizeObs) {
          this._thumbResizeObs.disconnect();
          this._thumbResizeObs = null;
        }
        if (this._thumbWindowResize) {
          window.removeEventListener("resize", this._thumbWindowResize);
          this._thumbWindowResize = null;
        }
      }

      clearThumbnailRailStyles() {
        const product = this.modalContent?.querySelector(".product--thumbnail");
        if (!product) return;
        const list = product.querySelector(".thumbnail-list");
        const arrowDown = product.querySelector(".arrow-down-scroll");
        if (list) list.style.maxHeight = "";
        if (arrowDown) arrowDown.style.top = "";
      }
    }
  );
}

if (!window.__quickAddVariantMediaSubscribed) {
  window.__quickAddVariantMediaSubscribed = true;
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const modal = document.querySelector("quick-add-modal[open]");
      if (!modal || !event.data?.variant?.id) return;
      const sid = event.data.sectionId;
      const pickers = modal.querySelectorAll(
        "variant-radios[data-original-section], variant-selects[data-original-section]"
      );
      const picker = [...pickers].find(
        (p) => p.dataset.originalSection === sid
      );
      if (!picker) return;
      const productRoot = modal.querySelector(".product");
      if (productRoot && typeof window.syncVariantMediaVisibility === "function") {
        window.syncVariantMediaVisibility(
          productRoot,
          String(event.data.variant.id)
        );
      }
      if (typeof modal.syncThumbnailRailWithMainImage === "function") {
        setTimeout(() => modal.syncThumbnailRailWithMainImage(), 320);
      }
    });
  }
}
